import MessageBuilderDispatcher from '../dispatcher/MessageBuilderDispatcher'
import MessageBuilderConstants from '../constants/MessageBuilderConstants'


var MessageBuilderActions = {

  blurInput: function () {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.BLUR_INPUT,
    });
  },

  focusInput: function (name) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.FOCUS_INPUT,
      name: name,
    });
  },

  help: function (redactor, help_type, lifecycle_event) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.HELP,
      redactor: redactor,
      help_type: help_type,
      lifecycle_event: lifecycle_event,
    });
  },

  /**
  * Initialize the MessageBuilderStore
  *
  * @param {object} opts
  */
  init: function (opts) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.INIT,
      opts: opts
    });
  },

  insert: function (text) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.INSERT,
      text: text
    });
  },

  insertImages: function (redactor) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.INSERT_IMAGES,
      redactor: redactor
    });
  },

  insertTextVariables: function (redactor) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.INSERT_TEXT_VARIABLES,
      redactor: redactor
    });
  },

  insertTextVariablesIntoInput: function (inputName) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.INSERT_TEXT_VARIABLES_INTO_INPUT,
      inputName: inputName
    });
  },

  setBody: function (body) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.SET_BODY,
      body: body
    });
  },

  setCaretPosition: function (position) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.SET_CARET_POSITION,
      position: position,
    });
  },

  setMessage: function (name, value) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.SET_MESSAGE,
      name: name,
      value: value
    });
  },

  setRedactor: function (redactor) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.SET_REDACTOR,
      redactor: redactor
    });
  },

  setValue: function (name, value) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.SET_VALUE,
      name: name,
      value: value,
    });
  },

  setImages: function (images) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.SET_IMAGES,
      images: images,
    });
  },

  setActiveTab: function (tab) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.SET_ACTIVE_TAB,
      tab: tab,
    });
  },

  setErrors: function (errors) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.SET_ERRORS,
      errors: errors
    });
  },

  setRoomTypes: function (room_types) {
    MessageBuilderDispatcher.dispatch({
      action: MessageBuilderConstants.SET_ROOM_TYPES,
      room_types: room_types,
    });
  },

};

export default MessageBuilderActions